var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulletPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4383 1.85711C9.07747 0.951491 10.4206 0.951491 11.0597 1.85711C11.4699 2.43823 12.2137 2.67991 12.8871 2.45085C13.9365 2.09389 15.0231 2.88335 15.0079 3.9917C14.9982 4.70292 15.4579 5.33565 16.1373 5.54615C17.1961 5.87419 17.6111 7.15156 16.9474 8.0393C16.5214 8.60895 16.5214 9.39105 16.9474 9.9607C17.6111 10.8484 17.1961 12.1258 16.1373 12.4538C15.4579 12.6643 14.9982 13.2971 15.0079 14.0083C15.0231 15.1167 13.9365 15.9061 12.8871 15.5491C12.2137 15.3201 11.4699 15.5618 11.0597 16.1429C10.4206 17.0485 9.07747 17.0485 8.4383 16.1429C8.02815 15.5618 7.28433 15.3201 6.61093 15.5491C5.56152 15.9061 4.47493 15.1167 4.49014 14.0083C4.4999 13.2971 4.04019 12.6643 3.36076 12.4538C2.30196 12.1258 1.88692 10.8484 2.55069 9.9607C2.97663 9.39105 2.97663 8.60895 2.55069 8.0393C1.88692 7.15156 2.30196 5.87419 3.36076 5.54615C4.04019 5.33565 4.4999 4.70292 4.49014 3.9917C4.47493 2.88335 5.56152 2.09389 6.61093 2.45085C7.28433 2.67991 8.02815 2.43823 8.4383 1.85711Z",
    fill: "#FFD456"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74902 9.27975L8.52952 11.0595L12.089 7.5",
    stroke: "#356733",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletPoint);
export default __webpack_public_path__ + "static/media/bullet-point.61dfce8f3c07c821aff8e23e3e505706.svg";
export { ForwardRef as ReactComponent };